export default "__VITE_ASSET__27fc30e1__"